// React
import React, { useState, useEffect } from "react";

import { OverlayTrigger, Popover, Button } from "react-bootstrap";

import { Link } from "react-router-dom";

// Local Storage
import ls from "local-storage";

export default function MainSideNav({ showAccountModal }) {

  function tappedAvatar() {
    showAccountModal();
  }

  var pictureURL = "";

  const localStorageAuthData = ls.get("authData");
  if (localStorageAuthData == null) {
    // dont do anything, they are unauth
  } else {
    const providerType = localStorageAuthData.providerType;
    if (providerType === "amazon") {
    } else if (providerType === "google") {
      pictureURL = localStorageAuthData.picture;
    }
  }

  let activeTab = "lists"; // default
  const pathname = window.location.pathname;
  if (pathname.indexOf("home") !== -1) {
    activeTab = "home";
  } else if (pathname.indexOf("/events") === 0) {
    activeTab = "events";
  } else if (pathname.indexOf("/contacts") === 0 || pathname.indexOf("/person") === 0) {
    activeTab = "contacts";
  } else if (pathname.indexOf("/list") === 0) {
    activeTab = "lists";
  } else if (pathname.indexOf("/team") === 0) {
    activeTab = "team";
  }

  return (
    <div className="MainSideNav">
      <img
        className="avatar"
        src={pictureURL}
        alt="user avatar"
        onClick={tappedAvatar}
      />

      {/* home nav */}
      {/*isAuthenticated ? (
        <Nav.Item onClick={handleLogout}>Logout</Nav.Item>
      ) : (
        <>
          <Nav.Link href="/signup">Signup</Nav.Link>
          <Nav.Link href="/login">Login</Nav.Link>
        </>
      )
      <Link
        to="/"
        className={`main-side-nav_item ${activeTab === "home" ? "active" : ""}`}
        title="home"
      >
        <svg width="32" height="30" fill="none" viewBox="0 0 32 30" xmlns="http://www.w3.org/2000/svg"><path d="m5.1379 16.517v12.414h7.2414v-9.3103h7.2414v9.3103h7.2414v-12.414" stroke="#737373" strokeLinecap="round" strokeMiterlimit="10"/><path d="M1 16L16 1L31 16" stroke="#737373" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10"/><path d="m20.655 2.0345h5.1724v5.1724" stroke="#737373" strokeLinecap="round" strokeMiterlimit="10"/></svg>
        <p>Home</p>
      </Link>

      <Link
        to="/"
        className={`main-side-nav_item ${
          activeTab === "events" ? "active" : ""
        }`}
        title="events"
      >
        <svg width="32" height="32" fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="m3.3999 2.0345h10.8v4.1379h16.8l-11.04 7.8621 11.04 7.6552h-21.6c0-2.7931 4.92-3.1035 4.92-3.1035h-10.8v-16.552h-0.12z" stroke="#737373" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10"/><path d="m14.2 6.1724v12.414" stroke="#737373" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10"/><path d="m9.3999 18.586v3.1035" stroke="#737373" strokeMiterlimit="10"/><path d="m1 1v30" stroke="#737373" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10"/></svg>
        <p>Events</p>
      </Link>
      */}

      <Link
        to="/contacts"
        className={`main-side-nav_item ${
          activeTab === "contacts" ? "active" : ""
        }`}
        title="people"
      >
        <svg width="32" height="28" fill="none" viewBox="0 0 32 28" xmlns="http://www.w3.org/2000/svg"><path d="m12.69 26.966h11.793s0-4.3448-0.6207-6.2069c-0.5173-1.6551-4.3449-2.5862-8.3793-4.1379v-3.1035s1.862-1.0344 1.862-4.1379c1.0345 0 1.0345-2.5862 0-2.5862 0-0.31034 1.0345-2.1724 0.6207-3.931-0.6207-2.4828-7.8621-2.4828-8.4827 0-3.1034-0.62069-1.3448 3.5172-1.3448 3.931-1.0345 0-1.0345 2.5862 0 2.5862 0 3.1035 2.1724 4.1379 2.1724 4.1379v3.1035c-3.6206 1.3448-8.1724 2.4828-8.6896 4.1379-0.62069 1.8621-0.62069 6.2069-0.62069 6.2069h11.69z" stroke="#737373" strokeLinejoin="round" strokeMiterlimit="10"/><path d="m28.414 26.966h2.5862s0-4.3448-0.6207-6.2069c-0.5172-1.6551-4.6551-3.1034-8.6896-4.6551v-2.069s2.1724-0.931 2.1724-4.0345c1.0345 0 1.0345-2.5862 0-2.5862 0-0.31034 1.0345-2.3793 0.6207-4.1379-0.3104-1.1379-2.5862-3-4.5517-1.7586" stroke="#737373" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10"/></svg>
        <p>Contacts</p>
      </Link>

      <Link
        to="/lists"
        className={`main-side-nav_item ${
          activeTab === "lists" ? "active" : ""
        }`}
        title="lists"
      >
        <svg width="32" height="27" fill="none" viewBox="0 0 32 27" xmlns="http://www.w3.org/2000/svg"><path d="M11.3448 4.10347H31M11.3448 13.4138H31M11.3448 22.7242H31M1 1H7.20692V7.20692H1V1ZM1 10.3104H7.20692V16.5173H1V10.3104ZM1 19.6208H7.20692V25.8277H1V19.6208Z" stroke="#737373" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10"/></svg>
        <p>Lists</p>
      </Link>

      <Link
        to="/team"
        className={`main-side-nav_item ${
          activeTab === "team" ? "active" : ""
        }`}
        title="team"
      >
        <svg width="32" height="28" fill="none" viewBox="0 0 32 28" xmlns="http://www.w3.org/2000/svg"><path d="m12.69 26.966h11.793s0-4.3448-0.6207-6.2069c-0.5173-1.6551-4.3449-2.5862-8.3793-4.1379v-3.1035s1.862-1.0344 1.862-4.1379c1.0345 0 1.0345-2.5862 0-2.5862 0-0.31034 1.0345-2.1724 0.6207-3.931-0.6207-2.4828-7.8621-2.4828-8.4827 0-3.1034-0.62069-1.3448 3.5172-1.3448 3.931-1.0345 0-1.0345 2.5862 0 2.5862 0 3.1035 2.1724 4.1379 2.1724 4.1379v3.1035c-3.6206 1.3448-8.1724 2.4828-8.6896 4.1379-0.62069 1.8621-0.62069 6.2069-0.62069 6.2069h11.69z" stroke="#737373" strokeLinejoin="round" strokeMiterlimit="10"/><path d="m28.414 26.966h2.5862s0-4.3448-0.6207-6.2069c-0.5172-1.6551-4.6551-3.1034-8.6896-4.6551v-2.069s2.1724-0.931 2.1724-4.0345c1.0345 0 1.0345-2.5862 0-2.5862 0-0.31034 1.0345-2.3793 0.6207-4.1379-0.3104-1.1379-2.5862-3-4.5517-1.7586" stroke="#737373" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10"/></svg>
        <p>Team</p>
      </Link>

      <div className="main-side-nav_item footer">
        <svg width="17" height="17" fill="none" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg"><path d="m8.5 11.761c-0.3913 0-0.65217 0.2608-0.65217 0.6521s0.26087 0.6522 0.65217 0.6522c0.39131 0 0.65218-0.2609 0.65218-0.6522s-0.26087-0.6521-0.65218-0.6521z" fill="#fff" fillOpacity="0.5"/><path d="M8.5 16C12.6421 16 16 12.6421 16 8.5C16 4.35786 12.6421 1 8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16Z" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeOpacity="0.5"/><path d="m6.5435 6.8696c0-1.1087 0.84782-1.9565 1.9565-1.9565 1.1087 0 1.9565 0.84782 1.9565 1.9565 0 1.1087-0.84783 1.9565-1.9565 1.9565v1.9565" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeOpacity="0.5"/></svg>
      </div>
    </div>
  );
}
